<section id="home" class="slider_area">
    <div class="carousel-inner">
        <div class="carousel-item active">
            <div class="slider-content">&nbsp;</div>
        </div>
    </div>
</section>

<section class="white-area">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10">
                <div class="section-title text-center pb-10">
                    <h3 class="title">{{ 'FOOTER.PRESS_TITLE' | translate }}</h3>
                    <p class="text">{{ 'FOOTER.PRESS_TEXT' | translate }}</p>
                </div>
                <div class="press-content">
                    <div class="press-contact">
                        <div class="contact-card">
                            <i class="lni lni-envelope"></i>
                            <h4>{{ 'FOOTER.PRESS_CONTACT_TITLE' | translate }}</h4>
                            <p>{{ 'FOOTER.PRESS_CONTACT_TEXT' | translate }}</p>
                            <a href="mailto:press@example.com" class="btn btn-primary">
                                {{ 'FOOTER.PRESS_CONTACT_BUTTON' | translate }}
                            </a>
                        </div>
                    </div>
                    <div class="press-releases">
                        <h4 class="section-subtitle">{{ 'FOOTER.PRESS_RELEASES_TITLE' | translate }}</h4>
                        <div class="releases-grid">
                            <article class="release-card">
                                <div class="release-date">{{ 'FOOTER.PRESS_RELEASE_1_DATE' | translate }}</div>
                                <h5>{{ 'FOOTER.PRESS_RELEASE_1_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.PRESS_RELEASE_1_EXCERPT' | translate }}</p>
                                <a href="#" class="read-more">{{ 'FOOTER.PRESS_READ_MORE' | translate }}</a>
                            </article>
                            <article class="release-card">
                                <div class="release-date">{{ 'FOOTER.PRESS_RELEASE_2_DATE' | translate }}</div>
                                <h5>{{ 'FOOTER.PRESS_RELEASE_2_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.PRESS_RELEASE_2_EXCERPT' | translate }}</p>
                                <a href="#" class="read-more">{{ 'FOOTER.PRESS_READ_MORE' | translate }}</a>
                            </article>
                            <article class="release-card">
                                <div class="release-date">{{ 'FOOTER.PRESS_RELEASE_3_DATE' | translate }}</div>
                                <h5>{{ 'FOOTER.PRESS_RELEASE_3_TITLE' | translate }}</h5>
                                <p>{{ 'FOOTER.PRESS_RELEASE_3_EXCERPT' | translate }}</p>
                                <a href="#" class="read-more">{{ 'FOOTER.PRESS_READ_MORE' | translate }}</a>
                            </article>
                        </div>
                    </div>
                    <div class="press-kit">
                        <h4 class="section-subtitle">{{ 'FOOTER.PRESS_KIT_TITLE' | translate }}</h4>
                        <div class="kit-grid">
                            <div class="kit-item">
                                <i class="lni lni-image"></i>
                                <h5>{{ 'FOOTER.PRESS_KIT_LOGOS' | translate }}</h5>
                                <p>{{ 'FOOTER.PRESS_KIT_LOGOS_DESC' | translate }}</p>
                                <a href="#" class="btn btn-outline-primary">
                                    {{ 'FOOTER.PRESS_DOWNLOAD' | translate }}
                                </a>
                            </div>
                            <div class="kit-item">
                                <i class="lni lni-gallery"></i>
                                <h5>{{ 'FOOTER.PRESS_KIT_PHOTOS' | translate }}</h5>
                                <p>{{ 'FOOTER.PRESS_KIT_PHOTOS_DESC' | translate }}</p>
                                <a href="#" class="btn btn-outline-primary">
                                    {{ 'FOOTER.PRESS_DOWNLOAD' | translate }}
                                </a>
                            </div>
                            <div class="kit-item">
                                <i class="lni lni-files"></i>
                                <h5>{{ 'FOOTER.PRESS_KIT_FACT_SHEET' | translate }}</h5>
                                <p>{{ 'FOOTER.PRESS_KIT_FACT_SHEET_DESC' | translate }}</p>
                                <a href="#" class="btn btn-outline-primary">
                                    {{ 'FOOTER.PRESS_DOWNLOAD' | translate }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> 